var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFavouritesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2182 8.6925L14.7613 7.69922L12.0199 2.15674L9.23869 7.64956L8.78178 8.64284L7.78851 8.79183L1.66992 9.67585L6.06021 13.9966L6.79523 14.7614L6.61644 15.7547L5.62316 21.8435L11.0961 19.0126L12.0199 18.5259L12.9833 18.9332L18.4563 21.8038L17.4134 15.715L17.2346 14.7217L17.9795 13.9966L22.3301 9.72551L16.2115 8.84149L15.2182 8.6925Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavouritesActive);
export default __webpack_public_path__ + "static/media/icon-favourites-active.5da33715017eb49babe75ff446825fbe.svg";
export { ForwardRef as ReactComponent };